import { render } from "./CompanyBankAccountFormContainer.vue?vue&type=template&id=67e5bb5e"
import script from "./CompanyBankAccountFormContainer.vue?vue&type=script&lang=js"
export * from "./CompanyBankAccountFormContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__